// Components
import { TableStateButton, TouchButton } from "./CommonButton";
// Recoil
import { useRecoilValue } from "recoil";
import { tableState } from "../../../atom/menu";

type ADPropsTypes = {
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
};

function ADView(props: ADPropsTypes) {
  // Recoil State
  const isTable = useRecoilValue(tableState);

  return (
    props.state && (
      <div
        className='ad-wrap'
        onClick={() => {
          props.setState(!props.state);
        }}
      >
        <img
          src={"/assets/images/menu/ad.png"}
          alt='ad'
          width={"100%"}
          height={"100%"}
        />
        {isTable.adult === 0 && <TableStateButton />}
        <TouchButton />
      </div>
    )
  );
}
export default ADView;
